import {Help} from "@material-ui/icons";
import {Button} from "@zendeskgarden/react-buttons";
import {ReactElement, useEffect, useRef, useState} from "react";
import * as css from "../styles/formula-info.module.scss";
import {BiCheck} from "react-icons/bi";


export default function FormulaInfo(): ReactElement {
    const [infoVisible, setInfoVisible] = useState(false);
    const dialogRef = useRef<HTMLDivElement>(null);

    // allow clicking anywhere outside of the dialog to close it
    useEffect(() => {
        if (!infoVisible) return;

        function handleClickOutside(evt: MouseEvent): void {
            if (dialogRef.current && !dialogRef.current.contains(evt.target as Node)) {
                setInfoVisible(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [infoVisible]);

    return (
        <div className={`${css.formulaInfo} ${infoVisible && css.isVisible}`}>
            <Button
                className={css.trigger}
                isBasic
                onClick={() => setInfoVisible(!infoVisible)}
                aria-expanded={infoVisible}
                aria-label="toggle details about our calculations"
            >
                <Button.StartIcon><Help /></Button.StartIcon>
                How do we calculate these numbers?
            </Button>

            <div ref={dialogRef} className={css.dialog} aria-hidden={!infoVisible}>
                <div className={css.section}>
                    <h5 className={css.sectionLabel}>Our Approach</h5>
                    <p>
                        Using your Actuals and target values, we calculate 
                        numbers for every month and Unit Type that will <span className={css.boldText}>get as close as we can to your goals.</span>
                    </p>

                    <div>
                        <span>Our calculated values make sure:</span>
                        <ul className={css.bullets}>
                            <li><BiCheck /> Move Ins stay at or above 0</li>
                            <li><BiCheck /> Rates fall within a range of 0% - 100%</li>
                            <li><BiCheck /> Renewal and Move Out rates always total 100%</li>
                        </ul>
                    </div>
                </div>

                <div className={css.section}>
                    <h5 className={css.sectionLabel}>Formula Used</h5>
                    <p className={css.formulaText}>
                        <span className={css.royal}>Move Ins</span>
                        =
                        <span className={css.yellow}>Occupancy</span>
                        -
                        (
                        <span className={css.orange}>Last Month Occupancy</span>
                        -
                        <span className={css.roman}>Move Outs</span>
                        )
                    </p>
                </div>
            </div>
        </div>
    );
}
